import { EmailTemplate, EmailTemplateUpdate, TemplateVariable, RenderedEmail } from '../../models/EmailTemplate';
import {
  FETCH_EMAIL_TEMPLATES,
  FETCH_EMAIL_TEMPLATES_SUCCESS,
  FETCH_EMAIL_TEMPLATES_FAILURE,
  UPDATE_EMAIL_TEMPLATE,
  UPDATE_EMAIL_TEMPLATE_SUCCESS,
  UPDATE_EMAIL_TEMPLATE_FAILURE,
  PREVIEW_EMAIL_TEMPLATE,
  PREVIEW_EMAIL_TEMPLATE_SUCCESS,
  PREVIEW_EMAIL_TEMPLATE_FAILURE,
  FETCH_TEMPLATE_VARIABLES,
  FETCH_TEMPLATE_VARIABLES_SUCCESS,
  FETCH_TEMPLATE_VARIABLES_FAILURE,
  SELECT_TEMPLATE,
  CLEAR_PREVIEW,
  CLEAR_SAVE_STATUS,
  SET_TEMPLATE_FIELD,
  SetTemplateFieldPayload,
} from './action-types';

export const fetchEmailTemplates = () => ({
  type: FETCH_EMAIL_TEMPLATES as typeof FETCH_EMAIL_TEMPLATES,
});

export const fetchEmailTemplatesSuccess = (templates: EmailTemplate[]) => ({
  type: FETCH_EMAIL_TEMPLATES_SUCCESS as typeof FETCH_EMAIL_TEMPLATES_SUCCESS,
  payload: templates,
});

export const fetchEmailTemplatesFailure = (error: string, correlationId?: string) => ({
  type: FETCH_EMAIL_TEMPLATES_FAILURE as typeof FETCH_EMAIL_TEMPLATES_FAILURE,
  payload: { error, correlationId },
});

export const updateEmailTemplate = (code: string, data: EmailTemplateUpdate) => ({
  type: UPDATE_EMAIL_TEMPLATE as typeof UPDATE_EMAIL_TEMPLATE,
  payload: { code, data },
});

export const updateEmailTemplateSuccess = (template: EmailTemplate) => ({
  type: UPDATE_EMAIL_TEMPLATE_SUCCESS as typeof UPDATE_EMAIL_TEMPLATE_SUCCESS,
  payload: template,
});

export const updateEmailTemplateFailure = (error: string, correlationId?: string) => ({
  type: UPDATE_EMAIL_TEMPLATE_FAILURE as typeof UPDATE_EMAIL_TEMPLATE_FAILURE,
  payload: { error, correlationId },
});

export const previewEmailTemplate = (code: string) => ({
  type: PREVIEW_EMAIL_TEMPLATE as typeof PREVIEW_EMAIL_TEMPLATE,
  payload: code,
});

export const previewEmailTemplateSuccess = (result: RenderedEmail) => ({
  type: PREVIEW_EMAIL_TEMPLATE_SUCCESS as typeof PREVIEW_EMAIL_TEMPLATE_SUCCESS,
  payload: result,
});

export const previewEmailTemplateFailure = (error: string, correlationId?: string) => ({
  type: PREVIEW_EMAIL_TEMPLATE_FAILURE as typeof PREVIEW_EMAIL_TEMPLATE_FAILURE,
  payload: { error, correlationId },
});

export const fetchTemplateVariables = () => ({
  type: FETCH_TEMPLATE_VARIABLES as typeof FETCH_TEMPLATE_VARIABLES,
});

export const fetchTemplateVariablesSuccess = (variables: TemplateVariable[]) => ({
  type: FETCH_TEMPLATE_VARIABLES_SUCCESS as typeof FETCH_TEMPLATE_VARIABLES_SUCCESS,
  payload: variables,
});

export const fetchTemplateVariablesFailure = (error: string, correlationId?: string) => ({
  type: FETCH_TEMPLATE_VARIABLES_FAILURE as typeof FETCH_TEMPLATE_VARIABLES_FAILURE,
  payload: { error, correlationId },
});

export const selectTemplate = (template: EmailTemplate | null) => ({
  type: SELECT_TEMPLATE as typeof SELECT_TEMPLATE,
  payload: template,
});

export const clearPreview = () => ({
  type: CLEAR_PREVIEW as typeof CLEAR_PREVIEW,
});

export const clearSaveStatus = () => ({
  type: CLEAR_SAVE_STATUS as typeof CLEAR_SAVE_STATUS,
});

export const setTemplateField = (field: SetTemplateFieldPayload['field'], value: SetTemplateFieldPayload['value']) => ({
  type: SET_TEMPLATE_FIELD as typeof SET_TEMPLATE_FIELD,
  payload: { field, value },
});

export type EmailTemplatesAction =
  | ReturnType<typeof fetchEmailTemplates>
  | ReturnType<typeof fetchEmailTemplatesSuccess>
  | ReturnType<typeof fetchEmailTemplatesFailure>
  | ReturnType<typeof updateEmailTemplate>
  | ReturnType<typeof updateEmailTemplateSuccess>
  | ReturnType<typeof updateEmailTemplateFailure>
  | ReturnType<typeof previewEmailTemplate>
  | ReturnType<typeof previewEmailTemplateSuccess>
  | ReturnType<typeof previewEmailTemplateFailure>
  | ReturnType<typeof fetchTemplateVariables>
  | ReturnType<typeof fetchTemplateVariablesSuccess>
  | ReturnType<typeof fetchTemplateVariablesFailure>
  | ReturnType<typeof selectTemplate>
  | ReturnType<typeof clearPreview>
  | ReturnType<typeof clearSaveStatus>
  | ReturnType<typeof setTemplateField>;
